import { selectors, actions } from './';
import table from './table-initial-data';

import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Table from '../../../shared/new-table/main';

import wrapMain from '../../wrap-main';

function List({ intl, rows, pagination }) {
	return (
		<div>
			<div className='banners-navigation'>
				<Link
					className='ui-btn ui-btn-primary'
					to='/mailings-new/images/editor'
				>
					{intl('Create image')}
				</Link>
			</div>
			<Table
				className='banners-table'
				table={table}
				rows={rows}
			/>
			{(rows.length < pagination.total) && (
				<div className='banners-button-wrapper'>
					<button
						className='ui-btn ui-btn-secondary banners-button'
						onClick={pagination.showMore}
					>
						{intl('Show more')}
					</button>
				</div>
			)}
		</div>
	);
}

function mapStateToProps(state) {
	return {
		rows: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		pagination: selectors.getPagination(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		pagination: bindActionCreators(actions.pagination, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		pagination: {
			...stateProps.pagination,
			...dispatchProps.pagination
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(List));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/image/list/main.js